import { eur } from "../../data/model";

const C = { navy: "#14213D", gold: "#B08D57", goldL: "#D9C29A", ink: "#3A3A3A", grid: "#E6DCC8" };

export const BarChart = ({ data, height = 220, format = (v) => v, testId }) => {
  const W = 600, H = height, pad = { l: 16, r: 16, t: 28, b: 40 };
  const max = Math.max(...data.map((d) => d.value)) * 1.15;
  const bw = (W - pad.l - pad.r) / data.length;
  return (
    <svg data-testid={testId} viewBox={`0 0 ${W} ${H}`} className="w-full h-auto chart" role="img">
      <line x1={pad.l} x2={W - pad.r} y1={H - pad.b} y2={H - pad.b} stroke={C.gold} strokeWidth="1" />
      {data.map((d, i) => {
        const h = ((H - pad.t - pad.b) * d.value) / max;
        const x = pad.l + i * bw + bw * 0.22;
        const y = H - pad.b - h;
        return (
          <g key={d.label}>
            <rect x={x} y={y} width={bw * 0.56} height={h} fill={d.highlight ? C.gold : C.navy} rx="2" />
            <text x={x + bw * 0.28} y={y - 8} textAnchor="middle" fontSize="13" fontWeight="600" fill={C.navy}>{format(d.value)}</text>
            <text x={x + bw * 0.28} y={H - pad.b + 18} textAnchor="middle" fontSize="11" fill={C.ink}>{d.label}</text>
            {d.sub && <text x={x + bw * 0.28} y={H - pad.b + 32} textAnchor="middle" fontSize="10" fill={C.gold}>{d.sub}</text>}
          </g>
        );
      })}
    </svg>
  );
};

export const LineChart = ({ series, labels, height = 280, testId }) => {
  const W = 640, H = height, pad = { l: 64, r: 16, t: 16, b: 34 };
  const all = series.flatMap((s) => s.values);
  const min = Math.min(0, ...all), max = Math.max(...all);
  const n = labels.length;
  const x = (i) => pad.l + (i * (W - pad.l - pad.r)) / (n - 1);
  const y = (v) => pad.t + ((max - v) * (H - pad.t - pad.b)) / (max - min);
  const ticks = [min, 0, max / 2, max].filter((v, i, a) => a.indexOf(v) === i);
  return (
    <svg data-testid={testId} viewBox={`0 0 ${W} ${H}`} className="w-full h-auto chart" role="img">
      {ticks.map((t) => (
        <g key={t}>
          <line x1={pad.l} x2={W - pad.r} y1={y(t)} y2={y(t)} stroke={t === 0 ? C.gold : C.grid} strokeWidth={t === 0 ? 1.4 : 1} strokeDasharray={t === 0 ? "" : "3 4"} />
          <text x={pad.l - 8} y={y(t) + 4} textAnchor="end" fontSize="10" fill={C.ink}>{eur(Math.round(t / 1000))}k</text>
        </g>
      ))}
      {labels.map((l, i) => (i % 2 === 0 ? <text key={l} x={x(i)} y={H - 12} textAnchor="middle" fontSize="10" fill={C.ink}>{l}</text> : null))}
      {series.map((s) => (
        <g key={s.name}>
          <polyline fill="none" stroke={s.color} strokeWidth={s.bold ? 2.6 : 1.6} strokeDasharray={s.dash || ""} points={s.values.map((v, i) => `${x(i)},${y(v)}`).join(" ")} />
          {s.marker && <circle cx={x(s.marker - 1)} cy={y(s.values[s.marker - 1])} r="5" fill={C.gold} stroke="#fff" strokeWidth="2" />}
        </g>
      ))}
    </svg>
  );
};

export const Legend = ({ items }) => (
  <div className="flex flex-wrap gap-5 text-xs text-[var(--ink-soft)] mt-2">
    {items.map((i) => (
      <span key={i.name} className="flex items-center gap-2">
        <span className="inline-block w-6 h-[3px]" style={{ background: i.color }} />
        {i.name}
      </span>
    ))}
  </div>
);
